export const secret_key = '123encryptionkey123';